// removed by extract-text-webpack-plugin
module.exports = {"resultContainer":"eHhF_I1x8XxtUVXzWHX87","eventTime":"_1qtizrgnH6E2BqBwmGKOCg","result":"_2DB_i27gRK9u7SIkOj_zva","teamName":"_2XLXFlidippR_nVGu8-iyN","footballTitle":"_3QmFp9_SNf-_j0XiNXREgL","even":"_2pQzhrQbvg3edR9yBrTFwX","eventDetailsWrapper":"tcKHxtTwdsWXlqRmqyUfK","eventDetails":"_3no1hvXaJqm3wsQsETPx2-","eventDetailsLine":"_13x0Z_1WwMjdX15M9BdmRw","eventDetailsLineLeft":"_2EF0jWi2suoldQV0cPY1ld","eventDetailsLineRight":"_1Z6VEeZPTtIhfmsAc4z96o"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/lockedBetFootball.css
// module id = 213
// module chunks = 0